import { Box, IconButton, MenuItem, Popover, styled } from "@mui/material";
import { H6 } from "components/Typography";
import useAuth from "hooks/useAuth";
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next"; // dummy language options
import { useClientProfileAPI } from "service/ClientProfileAPIService";

// custom styled components
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const IconWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  height: 24,
  width: 24,
  padding: "2px",
  "& img": {
    width: "100%",
    borderRadius: "50%",
    objectFit: "cover",
  },
}));
const ItemWrapper = styled(Box)(() => ({
  display: "flex",
  "& img": {
    width: "100%",
  },
}));

const LanguagePopover = ({ languageCode, userID }) => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const { refreshUserData } = useAuth();

  const clientProfileApi = useClientProfileAPI();

  const languageOptions = useMemo(() => ({
    en: {
      icon: "/static/flags/uk.png",
      label: t("languages.english"),
    },
    pt: {
      icon: "/static/flags/portugal.png",
      label: t("languages.portuguese"),
    },
  }), [t]);

  const formatLanguageCode = (lang) => `${lang}_${lang.toUpperCase()}`;

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const handleChangeLanguage = (language) => {
    const languageCodeToSend = formatLanguageCode(language);

    clientProfileApi.updateLanguage(userID, { language_code: languageCodeToSend }).then((response) => {
      refreshUserData(response.data);

      i18n.changeLanguage(language);
      setOpen(false);
    }).catch((_) => {
      setOpen(false);
    })
    ;
  };

  const currentUserLanguage = languageCode && languageCode.split("_")[0];
  const selectedLanguage = languageOptions[currentUserLanguage] || languageOptions["pt"];

  useEffect(() => {
    if (languageCode) {
      const userLanguage = languageCode.split("_")[0];

      if (i18n.language !== userLanguage) {
        i18n.changeLanguage(userLanguage);
      }
    }
  }, [languageCode, i18n.language]);

  return (
    <>
      <StyledIconButton onClick={handleOpen} ref={anchorRef}>
        <IconWrapper>
          <img alt={selectedLanguage.label} src={selectedLanguage.icon} />
        </IconWrapper>
      </StyledIconButton>
      <Popover
        keepMounted
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: "center",
          vertical: "bottom",
        }}
        PaperProps={{
          sx: {
            width: 150,
            padding: "0.5rem 0",
          },
        }}
      >
        {Object.keys(languageOptions).map((language) => (
          <MenuItem
            key={languageOptions[language].label}
            onClick={() => handleChangeLanguage(language)}
          >
            <ItemWrapper>
              {/* <img
             alt={languageOptions[language].label}
             src={languageOptions[language].icon}
            /> */}
              <H6 fontWeight={600} ml={1}>
                {languageOptions[language].label}
              </H6>
            </ItemWrapper>
          </MenuItem>
        ))}
      </Popover>
    </>
  );
};

export default LanguagePopover;
